<div class="p-6">
  @if (connectionPoint) {
    <app-card>
      <div class="flex gap-4">
        <div class="w-1/3">
          <div class="bg-gray-100 dark:bg-dark-hover dark:text-dark-text py-2 px-3 rounded-md font-semibold">
            {{ 'connectionpoint.masterdata' | translate }}
          </div>

          <app-value-details
            [collection]="connectionpointDetailsMasterData"
            [data]="connectionPoint"
          ></app-value-details>
        </div>
        <div class="w-1/3">
          <div class="bg-gray-100 dark:bg-dark-hover dark:text-dark-text py-2 px-3 rounded-md">
            {{ 'connectionpoint.location' | translate }}
          </div>

          <app-value-details
            [collection]="locationMasterData"
            [data]="connectionPoint"
          ></app-value-details>
        </div>
        <div class="w-1/3">
          <div class="bg-gray-100 dark:bg-dark-hover dark:text-dark-text py-2 px-3 rounded-md">
            {{ 'connectionpoint.key' | translate }}
          </div>

          <app-value-details
            [collection]="keyMasterData"
            [data]="connectionPoint"
          ></app-value-details>
        </div>
      </div>
      <div class="flex gap-4 mt-4">
        <div class="w-1/3">
          <div class="bg-gray-100 dark:bg-dark-hover dark:text-dark-text py-2 px-3 rounded-md font-semibold">
            {{ 'systemServices.title' | translate }}
          </div>
          <app-value-details
            [collection]="systemServicesDetailsMasterdata"
            [data]="connectionPoint"
          ></app-value-details>
        </div>
        <div class="w-1/3">
          <div class="bg-gray-100 dark:bg-dark-hover dark:text-dark-text py-2 px-3 rounded-md font-semibold">
            {{ 'connectionpoint.sharedInstallation.title' | translate }}
          </div>
          <app-value-details
            [collection]="sharedInstallationMasterdata"
            [data]="connectionPoint"
          ></app-value-details>
        </div>
        @if (connectionPoint.connectionPointOwnsConnectionRights) {
          <div class="w-1/3">
            <div class="bg-gray-100 dark:bg-dark-hover dark:text-dark-text py-2 px-3 rounded-md font-semibold">
              {{ 'connectionRight.sectionTitle' | translate }}
            </div>
            <app-value-details
              [collection]="connectionRightDetailsMasterdata"
              [data]="effectiveConnectionRight"
            ></app-value-details>
          </div>
        }
      </div>
    </app-card>
  }
</div>
